/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import SmoothScrollbar from "smooth-scrollbar";

let scrollY: number = 0
let previousY: number = 0
let limitY = 0
let pageHeight = 0

let YStore: any = {}

export function setHTMLScrollingPosition(e: React.UIEvent<HTMLDivElement, UIEvent>): void {
  const currentY = e.currentTarget.scrollTop
  limitY = e.currentTarget.scrollHeight - e.currentTarget.clientHeight
  pageHeight =  e.currentTarget.offsetHeight
  if (currentY > previousY) {
    scrollY = currentY
  } else {
    scrollY = -(currentY)
  }

  previousY = currentY
}

export function setScrollingPosition(e: SmoothScrollbar): void {
  const currentY = e.offset.y
  limitY = e.limit.y
  pageHeight = e.bounding.bottom
  if (currentY > previousY) {
    scrollY = currentY
  } else {
    scrollY = -(currentY)
  }

  previousY = currentY
}

export function getScrollPosition(): number {
  return scrollY
}

export function getScrollLimit(): number {
  return limitY
}

export function getScrollHeight(): number {
  return pageHeight
}

export function setY(name: string, value: number): void {
  let newY: any = YStore
  YStore[name] = value
}

export function getY(name: string): any {
  return YStore[name]
}

export const scrollGetY = (positionY: number, limit: number, damping: number = 1) => {
  if (positionY > 0) {
    const Y = (((positionY - limit) / limit) * 100) / 2
    if (positionY > limit / 2) {
      if (Y >= -20 && Y <= 20) {
        return Y * damping
      }
    }
  } else {
    const Y = (((-(positionY) - limit) / limit) * 100) / 2
    if (Y >= -20 && Y <= 20) {
      return Y * damping
    }
  }
}

export interface ProjectItemInterface {
  src: string,
  title: string,
  ref: any,
  type?: string,
  desc?: string
}